import { CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Icon,
    Typography,
} from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { updateLoader } from '../../../redux/slices/loaderSlice'
import { fetchRulesSubTemplates } from '../../../services/dtServices'
import SelectInput from '../../Common/SelectInput'
import { useTranslation } from 'react-i18next'
interface RulesTemplateListProps {
    isOpen: boolean
    onClose: any
    onSubmit: any
}

const RulesTemplateList = (props: RulesTemplateListProps): ReactElement => {
    const { isOpen, onClose, onSubmit } = props
    const { t } = useTranslation()

    const org = useAppSelector((state) => state.org.org)

    const dispatch = useAppDispatch()

    const [temValue, setTemValue] = useState('')
    const [totalTemplates, setTotalTemplates] = useState([])

    useEffect(() => {
        const setSubTemplateDetails = async () => {
            dispatch(updateLoader(true))
            const getSubTemplates: any = await fetchRulesSubTemplates(
                org?.id || '',
            )
            let updatedTotalTemplates: any = []
            if (getSubTemplates?.length) {
                updatedTotalTemplates = getSubTemplates
                updatedTotalTemplates = flattenEntityTemplates(getSubTemplates)
                updatedTotalTemplates = updatedTotalTemplates.filter(
                    (i: any) => !i.isAbstract,
                )
            }
            setTotalTemplates(updatedTotalTemplates)
            setTemValue(updatedTotalTemplates[0]?.templateId || '')
            dispatch(updateLoader(false))
        }

        if (isOpen && org?.id) {
            setSubTemplateDetails()
        } else {
            setTemValue('')
        }
    }, [isOpen])

    const flattenEntityTemplates = (entityTemplates: any[]) => {
        const allSubEntityTypes: any[] = []

        const traverse = (entityTemplates: any[]) => {
            for (const entityTemplate of entityTemplates) {
                allSubEntityTypes.push(entityTemplate)
                if (entityTemplate.subTemplates) {
                    traverse(entityTemplate.subTemplates)
                }
            }
        }

        traverse(entityTemplates)
        return allSubEntityTypes
    }

    const onChangeTemplate = (id: string, value: string) => {
        setTemValue(value)
    }

    const onSubmitSubTemplate = () => {
        const selectedTemplate: any = totalTemplates.find(
            (i: any) => i.templateId === temValue,
        )
        onSubmit(temValue, selectedTemplate?.templateName || '')
        setTemValue('')
        setTotalTemplates([])
    }

    return (
        <Dialog
            open={isOpen}
            scroll="paper"
            PaperProps={{
                sx: {
                    width: '400px',
                },
            }}
            aria-labelledby="rules-template-list-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{ padding: '10px 30px' }}
        >
            <Box>
                <DialogTitle
                    id="rules-template-list-dialog-title"
                    sx={{ padding: '0px' }}
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        padding="15px"
                        paddingLeft="20px"
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ paddingTop: '10px' }}
                        >
                            {t('selectType')}
                        </Typography>
                        <Icon
                            id="rule-template-list-close-icon"
                            onClick={() => onClose()}
                            sx={{ marginLeft: 'auto' }}
                            fontSize="small"
                            title={t('closeDialog')}
                            aria-label={t('closeDialog')}
                        >
                            <CloseOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                    </Box>
                </DialogTitle>
                <DialogContent
                    sx={{
                        height: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Box sx={{ width: 'calc(100%)' }}>
                            <SelectInput
                                label=""
                                id="subtemplatesList"
                                // value={path[path.length - 1]?.templateId}
                                value={temValue}
                                onChange={onChangeTemplate}
                                list={totalTemplates.map((i: any) => {
                                    return {
                                        ...{
                                            id: i.templateId,
                                            name: i.templateName,
                                        },
                                    }
                                })}
                                hasEmpty={false}
                                aria-label={t('selectType')}
                                //    errorMessage={''}
                            />
                        </Box>
                        <Box onClick={() => onSubmitSubTemplate()}>
                            <Button
                                id="rules-template-list-submit-button"
                                sx={{
                                    mt: 4,
                                }}
                                variant="contained"
                                fullWidth
                            >
                                {t('add')}
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
    )
}

export default RulesTemplateList
